import { mixed, object } from 'yup';
import * as Yup from 'yup';

// Validation similar to other date range reports
export const waitingListReportValidation = Yup.object().shape({
  fromCreatedDate: Yup.date()
    .required('שדה חובה')
    .test('from-before-to', 'תאריך התחלה גדול מתאריך סיום', function (value) {
      const to: Date | undefined = this.parent.toCreatedDate;
      if (!value || !to) return true;
      return value <= to;
    }),
  toCreatedDate: Yup.date()
    .required('שדה חובה')
    .test('to-after-from', 'תאריך סיום קטן מתאריך התחלה', function (value) {
      const from: Date | undefined = this.parent.fromCreatedDate;
      if (!value || !from) return true;
      return value >= from;
    }),
});
